import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCardTitle, CFormLabel, CFormSelect, CModal, CModalBody, CModalFooter, CTooltip, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CModalHeader, CModalTitle, CSpinner } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import PatientPhysicalExaminationData from '../../../src/services/general/physicalExaminationData.api'
import PESelectedData from './PESelectedData'
import { RichTextEditorComponent, Inject, HtmlEditor, Toolbar, QuickToolbar, Link, Image } from '@syncfusion/ej2-react-richtexteditor'
import { FilePlus2, Plus } from 'lucide-react'
import HierarchyComponents from './HierarchyComponents'
import { data } from '../../utils/GESelectedData'
import PEHierarchyComponents from './PEHierarchyComponents'
import SaveExtra from '../../services/general/saveExtraData.api'
import ProvidereGeneralExamination from '../../components/shared/ProvidereGeneralExamination'
import { toastConfig } from '../../constants/other.config'
import toast from 'react-hot-toast'
import ModifyPatientMap from '../../services/general/modifyPatientMap.api'
import Pageloader from '../../components/shared/Pageloader'
import Graytextarea from '../../components/Graytextarea'
import { useIndexedDB } from '../../context/IndexedContext'
const ProviderPhysicalExaminationTabTest = ({ patientID = '-1', isAllotedToProvider = false, noteID, patientDiagnosis,peAdded, setPEAdded,patientDBData , setPatientDBData }) => {
  console.log(isAllotedToProvider, 'isAllotedToProvider')
  const [physicalExaminationData, setPhysicalExaminationData] = useState([])
  const [generalExaminationData, setGeneralExaminationData] = useState([])
  const [diagnosisExaminationData, setDiagnosisExaminationData] = useState([])
  const [visible, setVisible] = useState(false)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  // const [patientDiagnosis, setPatientDiagnosis] = useState([])
  const [globalRemarkText, setGlobalRemarkText] = useState('')
  const [globalRemarkTextToShow, setGlobalRemarkTextToShow] = useState('')
  const [showGlobalRemarkModal, setShowGlobalRemarkModal] = useState(false)
 

  console.log('patientDiagnosis=>', patientDiagnosis)
    const { getPEData, getTestOfflineData, getProviderDetails,saveTestOfflineData } = useIndexedDB()
    const fetchPEdata = async () => {
        const data = await getPEData()
        console.log(data,'data in indexed db')
        setDiagnosisExaminationData(data?.Diagnosis)
        setGeneralExaminationData(data?.General)
      }
  const getGeneralExaminationData = async () => {
    console.log('getGeneralExaminationData called')

    try {
      let data = await SaveExtra('Get_By_Type', 'PhysicalExaminationDummyData', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setGeneralExaminationData(data[0]?.Data)

      console.log(' datatdtatdatd', data[0]?.Data)
    } catch (error) {
      console.log('error', error)
      // toast.error('Failed to fetch data', toastConfig)
    } finally {
    }
  }

  const getDiagnosisExaminationData = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'DiagnosisExaminationDummyData', '', '')
      data = JSON.parse(data.d)?.Data || []

      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }
      let diagnosisQestion = data[0]?.Data
      console.log('diagnosisQestion. before', diagnosisQestion, patientDiagnosis)
      diagnosisQestion = diagnosisQestion.filter((item) => patientDiagnosis.includes(item.name.trim()))
      console.log('diagnosisQestion', diagnosisQestion, patientDiagnosis)

      setDiagnosisExaminationData(data[0]?.Data)
    } catch (error) {
      console.log('error', error)
      // toast.error('Failed to fetch data', toastConfig)
    } finally {
      console.log('getDiagnosisExaminationData called')
    }
  }

 
  const fetchData = async () => {
    setIsPageLoading(true)
    let lastGeneralExamination = []
    let lastLastDiagnosisExamination = []
    // let response = await PatientPhysicalExaminationData('Get_By_Patient', patientID)
    // const parsedData = JSON.parse(response.d).Data || []


     const data = await getTestOfflineData()
     const loggedUserID = await getProviderDetails()
     const PEData = data[loggedUserID?.ID] || []
     const parsedData = PEData[patientID]?.PEPatientData || []
    console.log(parsedData, 'parsedData pe')
    const findLastDiagnosisExaminationData = parsedData.filter((item) => item.Type === 'DiagnosisExaminationData' && item?.NoteID === noteID?.toString()) || []
    const findLastGeneralDiagnosisExamination = parsedData.filter((item) => item.Type === 'GeneralExaminationData' && item?.NoteID === noteID?.toString()) || []

    const globalRemarks = parsedData.filter((item) => item.Type === "PhysicalExaminationGlobalRemark" && item?.NoteID === noteID?.toString());

    const lastGlobalRemark = globalRemarks[globalRemarks.length - 1] || null;

    const jsonRemarkGlobalRemark = lastGlobalRemark
      ? JSON.parse(lastGlobalRemark.JsonData)
      : null;

    // if (findLastGeneralDiagnosisExamination.length > 0) {
    //     lastGeneralExamination = JSON.parse(findLastGeneralDiagnosisExamination[findLastGeneralDiagnosisExamination.length - 1]?.JsonData) || []
    // setPhysicalExaminationData([...lastLastDiagnosisExamination])
    // }
    // if (findLastDiagnosisExaminationData.length > 0) {
    //     lastLastDiagnosisExamination = JSON.parse(findLastDiagnosisExaminationData[findLastDiagnosisExaminationData.length - 1]?.JsonData) || []
    //     setPhysicalExaminationData([...lastGeneralExamination])
    // }
    console.log(jsonRemarkGlobalRemark, 'jsonRemarkGlobalRemark')
    setGlobalRemarkTextToShow(jsonRemarkGlobalRemark?.globalRemarkText || "")
    setGlobalRemarkText(jsonRemarkGlobalRemark?.globalRemarkText || '')
    console.log(findLastDiagnosisExaminationData, findLastGeneralDiagnosisExamination, patientID, 'findLastDiagnosisExaminationData,findLastGeneralDiagnosisExamination,patientID')
    if (findLastGeneralDiagnosisExamination.length > 0) {
      const parsedGeneral = JSON.parse(findLastGeneralDiagnosisExamination[findLastGeneralDiagnosisExamination.length - 1]?.JsonData)
      lastGeneralExamination = Array.isArray(parsedGeneral) ? parsedGeneral : []
      console.log(parsedGeneral, 'findLastGeneralDiagnosisExamination')
      console.log(lastGeneralExamination, 'lastGeneralExamination')
      setGeneralExaminationData(lastGeneralExamination)
    } else {
      // getGeneralExaminationData()
      fetchPEdata()
    }
    // Parse and set diagnosis examination data
    if (findLastDiagnosisExaminationData.length > 0) {
      const parsedDiagnosis = JSON.parse(findLastDiagnosisExaminationData[findLastDiagnosisExaminationData.length - 1]?.JsonData)
      console.log(parsedDiagnosis, 'findLastDiagnosisExaminationDatafindLastDiagnosisExaminationData')
      lastLastDiagnosisExamination = Array.isArray(parsedDiagnosis) ? parsedDiagnosis : []
      setDiagnosisExaminationData(lastLastDiagnosisExamination)
    } else {
      // getDiagnosisExaminationData()
      fetchPEdata()
    }
    console.log(lastGeneralExamination, lastLastDiagnosisExamination, 'lastGeneralExamination, lastLastDiagnosisExamination')
    setPhysicalExaminationData([...lastGeneralExamination, ...lastLastDiagnosisExamination])
    setIsPageLoading(false)
  }
  console.log(physicalExaminationData, 'physicalExaminationData')
  useEffect(() => {
    fetchData()
  }, [])
  console.log(' data for formate ', physicalExaminationData)
  const [renderData, setRenderData] = useState(null)
  const [count, setCount] = useState(1)
  const [formattedOutput, setFormattedOutput] = useState('')
  const [finalHtml, setFinalHtml] = useState('')
  const formatDataForAPI = (data) => {
    let output = ''
    let parsedData = data
    // try {
    //     parsedData = JSON.parse(data);
    // } catch (error) {
    //     console.error("Error parsing data:", error);
    //     return "";
    // }
    // Filter accordions
    const accordions = parsedData.filter((item) => item.type === 'accordion')
    // Format the accordions
    output += 'General Examination\n'
    accordions.forEach((accordion) => {
      if (accordion.isSelected || (accordion.hierarchy && accordion.hierarchy.some((child) => child.isSelected))) {
        output += `  ${accordion.name}\n`
        // Format hierarchy items
        accordion.hierarchy.forEach((headerItem) => {
          if (headerItem.isSelected) {
            output += `    ${headerItem.name.split('-')[0]}\n`
            // Format any children
            if (headerItem.hierarchy && headerItem.hierarchy.length > 0) {
              formatHierarchyItems(headerItem.hierarchy, output, 6)
            }
            // Add input data if present
            if (headerItem.inputData) {
              output += `      ${headerItem.inputData}\n`
            }
          }
        })
      }
    })
    return output
  }
  const formatHierarchyItems = (items, outputString, indentLevel) => {
    if (!items || !items.length) return outputString
    items.forEach((item) => {
      if (item.isSelected) {
        const indent = ' '.repeat(indentLevel)
        const itemName = item.name.split('-')[0]
        if (item.type === 'subHeader') {
          outputString += `${indent}${itemName}: `
          // If this subheader has selected children, add them inline
          const selectedChildren = item.hierarchy?.filter((child) => child.isSelected) || []
          if (selectedChildren.length > 0) {
            const childrenText = selectedChildren.map((child) => child.name.split('-')[0]).join(', ')
            outputString += `${childrenText}`
          } else {
            outputString += '\n'
          }
        } else {
          outputString += `${indent}${itemName}\n`
        }
        // Add input data if present
        if (item.inputData) {
          outputString += `${indent}  Reason: ${item.inputData}\n`
        }
        // Recursively format children with increased indentation
        if (item.hierarchy && item.hierarchy.length > 0 && item.type !== 'subHeader') {
          // Skip children that were already processed inline
          formatHierarchyItems(item.hierarchy, outputString, indentLevel + 2)
        }
      }
    })
    return outputString
  }
  const RenderHierarchy = ({ item }) => {
    if (!item.hierarchy || item.hierarchy.length === 0) {
      return item.isSelected == true ? (
        <>
          <span className="">{item.name.split('-')[0]}</span>
          {item?.inputData && <span className=" ms-2">Reason : {item?.inputData?.split('-')[0]}</span>}
        </>
      ) : null
    }
    return (
      <div
        className={`d-flex ${item.type === 'title' || item.type === 'option' ? 'flex-column' : 'flex-row'}`}
        style={{
          fontWeight: item.type === 'title' || item.type === 'header' ? '700' : '500',
        }}
      >
        <span className="">{item.name.split('-')[0]}</span>
        {item.hierarchy.map((child, index) => (
          <RenderHierarchy key={index} item={child} />
        ))}
      </div>
    )
  }
  const convertToHTML = (item, tabCount = 0, parent) => {
    const indent = ''
    let html = ''
    if (!item.hierarchy || item.hierarchy.length === 0) {
      if (item.isSelected) {
        const parts = item.name.split('-')[0]
        html += `${indent}${parts}, `
        if (item.name.split('-')[0] === 'Unable to test' && item.inputData) {
          html += `  (Reason - ${item.inputData})  <br/>`
        }
      }
      return html
    }
    if (!item.isSelected) return ''
    if (item.type === 'header') {
      html += `<br/><b>${indent}${item.name.split('-')[0]}</b> `
    } else if (item.type === 'subHeader') {
      if (parent?.type === 'header' && parent?.hierarchyType !== 'multi') {
        html += `<br/>`
      }
      html += ` - <i> <u> ${indent}${item.name.split('-')[0]}</u>:&nbsp</i>`
    }
    if (item.type === 'option') {
      html += `<span>${indent}${item.name.split('-')[0]}</span>, `
    }
    if (item.inputData) {
      html += `${indent}<span style="color: gray;">(${item.inputData})</span><br/>`
    }
    item.hierarchy.forEach((child) => {
      html += convertToHTML(child, tabCount + 1, item)
    })
    return html
  }
  // const RenderAccordion = ({ item }) => {
  //     if (!item.isSelected && !item.hierarchy.some(child => child.isSelected)) {
  //         return null;
  //     }
  //     return (
  //         <div >
  //             <div className=" fw-bold " style={{ fontSize: "16px", textDecoration: "underline" }}>
  //                 {item.name}
  //             </div>
  //             {item.hierarchy.map((bodyItem, idx) => (
  //                 <div key={idx} className="d-flex">
  //                     <RenderOption item={bodyItem} parent={item} tabCount={1} />
  //                 </div>
  //             ))}
  //         </div>
  //     );
  // };
  // inside a component
  const RenderAccordion = ({ item }) => {
    if (!item.isSelected && !item.hierarchy.some((child) => child.isSelected)) return null
    let finalHtml = `<b>${item.name}</b><br/>`
    item.hierarchy.forEach((bodyItem) => {
      finalHtml += convertToHTML(bodyItem)
    })
  }
  // Adding the physical exmaination data
  useEffect(() => {
    if (physicalExaminationData) {
      setRenderData(physicalExaminationData)
      const formatted = formatDataForAPI(physicalExaminationData)
      setFormattedOutput(formatted)
      const html = physicalExaminationData
        .filter((item) => item.type === 'accordion' && (item.isSelected || item.hierarchy?.some((child) => child.isSelected)))
        .map((item) => {
          let sectionHtml = `<b style="font-size:16px; text-decoration:underline;">${item.name}</b><br/> `
          item.hierarchy.forEach((bodyItem) => {
            sectionHtml += convertToHTML(bodyItem, 1, item)
          })
          return sectionHtml
        })
        .join('<br/> ')
      const cleanedHtml = html
        .replace(/(<br\/?>\s*){2,}/g, '<br/>')
        .replace(/^(<br\/?>)+/, '')
        .replace(/(<br\/?>)+$/, '')
      setFinalHtml(cleanedHtml)
    }
  }, [physicalExaminationData])
  console.log(physicalExaminationData, 'physicalExaminationData======')



  const handleAddPeOffline = async()=>{
    try {
     let patientData = await getTestOfflineData()
     console.log(patientData,'patientData before')
     const loggedUserID = await getProviderDetails()
    //  put the data at same place of patientID.pedpatientdata
    // patientData = {
    //   ...patientData,
    //   [loggedUserID?.ID]: {
    //     ...patientData[loggedUserID?.ID],
    //     [patientID]: {
    //       ...patientData[loggedUserID?.ID][patientID],
    //       PEPatientData:
          
    //         [
    //           {
    //             patientID:patientID?.toString(),
    //             NoteID:noteID?.toString(),
    //             Type:'GeneralExaminationData',
    //             JsonData:JSON.stringify(generalExaminationData),
    //             toBeInserted: true
    //           },
    //           {
    //             patientID:patientID?.toString(),
    //             NoteID:noteID?.toString(),
    //             Type:'DiagnosisExaminationData',
    //             JsonData:JSON.stringify(diagnosisExaminationData),
    //             toBeInserted: true
    //           }
    //         ]
    //     }
    //   }
    // }
    patientData = {
  ...patientData,
  [loggedUserID?.ID]: {
    ...patientData[loggedUserID?.ID],
    [patientID]: {
      ...patientData[loggedUserID?.ID][patientID],

      PEPatientData: [
        ...(patientData[loggedUserID?.ID][patientID]?.PEPatientData || [])
          .filter(
            (item) =>
              item.Type !== "GeneralExaminationData" &&
              item.Type !== "DiagnosisExaminationData"
          ),

        {
          patientID: patientID?.toString(),
          NoteID: noteID?.toString(),
          Type: "GeneralExaminationData",
          JsonData: JSON.stringify(generalExaminationData),
          toBeInserted: true,
        },

        {
          patientID: patientID?.toString(),
          NoteID: noteID?.toString(),
          Type: "DiagnosisExaminationData",
          JsonData: JSON.stringify(diagnosisExaminationData),
          toBeInserted: true,
        },
      ],
    },
  },
};

    setPatientDBData((p) => {
  const filtered = (p.PEPatientData || []).filter(
    item => item.Type !== 'GeneralExaminationData' &&
            item.Type !== 'DiagnosisExaminationData' 
  )


  return {
    ...p,
    PEPatientData: [
      ...filtered,
      {
        patientID: patientID?.toString(),
        NoteID: noteID?.toString(),
        Type: 'GeneralExaminationData',
        JsonData: JSON.stringify(generalExaminationData),
        toBeInserted: true
      },
      {
        patientID: patientID?.toString(),
        NoteID: noteID?.toString(),
        Type: 'DiagnosisExaminationData',
        JsonData: JSON.stringify(diagnosisExaminationData),
        toBeInserted: true
      }
    ]
  }
})
    await saveTestOfflineData(patientData)

    } catch (error) {
    }
    finally {
      setPEAdded(p=>!p)
    }
  }

  const handleSave = async () => {
    setIsPageLoading(true)
    const addPE = async (type, data) => {
      try {
        console.log('generalExaminationData inserted', generalExaminationData)
        let response = await PatientPhysicalExaminationData('Insert', patientID, noteID, type, JSON.stringify(data))
      } catch (error) {
        toast.error('Failed to save General Examination Data', toastConfig)
        console.error('Error saving General Examination Data:', error)
      } finally {
        setIsPageLoading(false)
      }
    }

    // await addPE('GeneralExaminationData', generalExaminationData)
    // await addPE('DiagnosisExaminationData', diagnosisExaminationData)
    await handleAddPeOffline()
    toast.success('Physical Examination Data saved successfully', toastConfig)
    await fetchData()
    setVisible(false)
    setIsSaving(false)
  }

  // const getPatientDiagnosis = async () => {
  //   let diagnosisData = await ModifyPatientMap('GETALL', patientID, '')

  //   let tempData = JSON.parse(diagnosisData.d)?.Data

  //   diagnosisData = tempData.filter((obj) => {
  //     if (patientID == obj.PatientID) {
  //       return obj
  //     }
  //   })
  //   console.log(diagnosisData, tempData, 'diagnosisData tempdata')
  //   let patientD = []
  //   try {
  //     patientD = diagnosisData[0]?.Diagnosis?.split(',')

  //     // setPatientDiagnosis(patientD)
  //     console.log('patientD===>', patientD, diagnosisData)
  //   } catch (e) { }
  // }
  // useEffect(() => {
  //   getPatientDiagnosis()
  // }, [visible])

  const userData = JSON.parse(localStorage.getItem('user'))
  const role = userData?.Role

  const [addingGlobalRemarkLoading, setAddingGlobalRemarkLoading] = useState(false)



const handleAddPeGlobalRemarkOffline = async () => {
  try {
    let patientData = await getTestOfflineData()
    console.log(patientData, 'patientData before')

    const loggedUserID = await getProviderDetails()
    const userId = loggedUserID?.ID

    // Ensure structure exists
    if (!patientData[userId]) patientData[userId] = {}
    if (!patientData[userId][patientID]) patientData[userId][patientID] = {}
    if (!patientData[userId][patientID].PEPatientData)
      patientData[userId][patientID].PEPatientData = []

    // Filter out existing PhysicalExaminationGlobalRemark
    const filteredPEData = patientData[userId][patientID].PEPatientData.filter(
      (item) => item.Type !== 'PhysicalExaminationGlobalRemark'
    )

    // Add new one
    const updatedPEData = [
      ...filteredPEData,
      {
        patientID: patientID?.toString(),
        NoteID: noteID?.toString(),
        Type: 'PhysicalExaminationGlobalRemark',
        JsonData: JSON.stringify({ globalRemarkText }),
        toBeInserted: true,
      },
    ]

    // Update patientData structure
    patientData[userId][patientID] = {
      ...patientData[userId][patientID],
      PEPatientData: updatedPEData,
    }
        setPatientDBData((p)=>({
      ...p,
    PEPatientData:updatedPEData
    }))

    console.log(patientData, 'patientData after')
    await saveTestOfflineData(patientData)
      setPEAdded(p=>!p)
  } catch (error) {
    console.error('Error in handleAddPeGlobalRemarkOffline:', error)
  }
}

  const handleAddGlobalRemarkPE = async () => {
    // const a = await add
    setAddingGlobalRemarkLoading(true)
    await handleAddPeGlobalRemarkOffline()
    // let response = await PatientPhysicalExaminationData('Insert', patientID, noteID, 'PhysicalExaminationGlobalRemark', JSON.stringify({ globalRemarkText }))
    setShowGlobalRemarkModal(false)
    setAddingGlobalRemarkLoading(false)
    await fetchData()
  }

    useEffect(()=>{
      fetchPEdata()
    },[])

  return (
    <div className="d-flex flex-column gap-4">
      <div className="patient-note-section-header d-flex align-items-center gap-2 px-4 py-2" style={{ background: 'var(--ui-dashboard-surface-2, #191919)' }}>
        <h7 className="patient-note-section-title fs-7">Physical Examination</h7>
        <div></div>
        {isAllotedToProvider && (
          <>
            <CFormLabel
              className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
              onClick={() => setVisible((p) => !p)}
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '20px',
                background: '#4363F2',
                cursor: 'pointer',
              }}
            >
              <Plus className="patient-note-action-icon" strokeWidth={2} size={15} />
            </CFormLabel>
            <CFormLabel
              className="patient-note-action d-flex mt-2 flex-column align-items-center justify-content-center shadow"
              onClick={() => setShowGlobalRemarkModal((p) => !p)}
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '20px',
                background: '#4363F2',
                cursor: 'pointer',
              }}
            >
              <FilePlus2 className="patient-note-action-icon" strokeWidth={2} size={15} />
            </CFormLabel>
          </>
        )}
      </div>

      <div>
        <p className="p-0 m-0 mb-0">{globalRemarkTextToShow}</p>
      </div>

      <div className="ProviderPhysicalExaminationTab">
        {isPageLoading ? (
          // <div className="p-4">
          //   <CSpinner size="sm" className="me-2" />
          //   Loading...
          // </div>
          <Pageloader isLoading={isPageLoading} />
        ) : (
          <>
            {finalHtml ? (
              <div className="mt-2  PhysicalExaminationVisualNote" style={{ background: '#191919' }}>
                <RichTextEditorComponent
                  value={finalHtml ? finalHtml : 'No Physical Examination '}
                  readonly
                  style={{
                    border: 0,
                  }}
                  backgroundColor={'#191919'}
                   
                  enabled={true}
                  toolbarSettings={{ enable: false }}
                  height={physicalExaminationData.length > 0 && physicalExaminationData.every((item) => item.isSelected === false) ? 0 : '100%'}
                >
                  <Inject services={[Toolbar, HtmlEditor]} />
                </RichTextEditorComponent>
              </div>
            ) : (
              <div className="d-flex justify-content-center p-8 align-items-center text-muted" style={{ height: '50px' }}>
                <div
                  style={{
                    fontSize: '15px',
                    fontWeight: '600px',
                    color: 'gray',
                  }}
                >
                  No Physical Examination
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <CModal size="xl" backdrop="static" visible={visible} onClose={() => setVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        {/* <CModalHeader>
          <CModalTitle id="StaticBackdropExampleLabel">Modal title</CModalTitle>
        </CModalHeader> */}
        <CModalBody
          style={{
            height: '650px',
            overflowY: 'auto',
            padding: '24px',
            backgroundColor: '#282828',
          }}
        >
          <CAccordion alwaysOpen activeItemKey={1} className={`  ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} `}>
            {/* General Examination Section */}
            <CAccordionItem itemKey={1} className="mb-3 border-0 shadow-sm rounded">
              <CAccordionHeader className="patient-note-section-title fw-bold">General Examination</CAccordionHeader>
              <CAccordionBody className="  p-4 rounded-bottom">
                {generalExaminationData?.length > 0 ? (
                  <ProvidereGeneralExamination generalExaminationData={generalExaminationData} setGeneralExaminationData={setGeneralExaminationData} />
                ) : (
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <CSpinner color="primary" />
                  </div>
                )}
              </CAccordionBody>
            </CAccordionItem>
          </CAccordion>
          {diagnosisExaminationData?.length > 0 ? (
            <CAccordion alwaysOpen className={`  ${role == 'provider' ? 'accordion-dark' : 'accordion-light'} `}>
              {diagnosisExaminationData
                .filter((item) => patientDiagnosis?.includes(item.name))
                .map((item, index) => (
                  <CAccordionItem itemKey={index} key={index} className="mt-3 border rounded-1">
                    <CAccordionHeader>{item.name}</CAccordionHeader>
                    <CAccordionBody className="p-0" style={{ overflow: 'auto' }}>
                      <PEHierarchyComponents
                        viewData={item}
                        onDataUpdate={(updatedItem) => {
                          setDiagnosisExaminationData((prev) => prev.map((el) => (el.id === updatedItem.id ? updatedItem : el)))
                        }}
                      />
                    </CAccordionBody>
                  </CAccordionItem>
                ))}
            </CAccordion>
          ) : (
            // <ProvidereGeneralExamination generalExaminationData={diagnosisExaminationData} setGeneralExaminationData={setDiagnosisExaminationData} patientDiagnosis={patientDiagnosis} addFilter={true} />
            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
              <CSpinner color="primary" />
            </div>
          )}
        </CModalBody>

        <CModalFooter className="" style={{ background: '#282828' }}>
          <CButton
            variant="outline"
            color="secondary"
            onClick={() => setVisible(false)}
            style={{
              backgroundColor: '#333', // dark gray
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            Close
          </CButton>
          <CButton
            variant="outline"
            color="primary"
            onClick={() => {
              handleSave(), setIsSaving(true)
            }}
            style={{
              backgroundColor: '#4363F2', // blue
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
          >
            {isSaving ? (
              <>
                <CSpinner size="sm" className="me-2" />
                Saving...
              </>
            ) : (
              'Save'
            )}
          </CButton>
        </CModalFooter>
      </CModal>
      <CModal backdrop="static" visible={showGlobalRemarkModal} onClose={() => setShowGlobalRemarkModal(false)} aria-labelledby="StaticBackdropExampleLabel">
        <CModalHeader style={{ background: '#282828', color: 'white' }}>
          <CModalTitle style={{ color: 'white' }} id="StaticBackdropExampleLabel">
            Add Remark
          </CModalTitle>
        </CModalHeader>
        <CModalBody
          style={{
            overflowY: 'auto',
            color: 'white',
            padding: '24px',
            backgroundColor: '#282828',
          }}
        >
          <Graytextarea
            style={{
              backgroundColor: '#282828',
              color: 'white',
              border: '1px solid #989898',
              height: '200px',
            }}
            placeholder="Enter remark for Physical Education"
            value={globalRemarkText}
            rows={4}
            onChange={(e) => setGlobalRemarkText(e.target.value)}
          />
        </CModalBody>
        <CModalFooter style={{ background: '#282828' }}>
          <CButton
            style={{
              backgroundColor: '#333', // dark gray
              border: '1px solid gray',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            color="secondary"
            onClick={() => setShowGlobalRemarkModal(false)}
          >
            Close
          </CButton>
          <CButton
            onClick={async () => {
              await handleAddGlobalRemarkPE()
            }}
            style={{
              backgroundColor: '#4363F2', // blue
              border: 'none',
              color: 'white',
              borderRadius: '6px',
              padding: '8px 20px',
            }}
            variant="outline"
            color="primary"
          >
            {addingGlobalRemarkLoading ? 'Saving...' : 'Save'}
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default ProviderPhysicalExaminationTabTest
